import { ReactNode } from 'react';

import classNames from 'classnames';
import _ from 'lodash';

import GuarantorPerson from './GuarantorPerson';
import LimitedCompanyPerson from './LimitedCompanyPerson/LimitedCompanyPerson';
import { renderPhones } from './renderHelpers/renderPhones';
import { Person as TPerson } from './types/PersonalInformation.types';
import Address from '../../components/Address';

type PersonProps = {
    person: TPerson;
    personIndex: number;
    fetchedAddresses: { addresses: { list: string[] } };
    manualAddressesState: [];
    formLayout: string;
    isInIndicativeOfferFlow: boolean;
    toggleManualAddress: (
        personUID: number,
        addressIndex: number
    ) => { type: string; path: string };
    onAddressChange: (input: string) => void;
    onAddressSelect: (addressIndex: number, address: string) => void;
    onMonthSelect: (month: string) => void;
    disableBusinessIncome: (disabled: boolean) => void;
    disableMonthlyOtherHouseholdIncome: (disabled: boolean) => void;
    onCountrySelect: (country: string) => void;
    renderAddresses: (person: TPerson) => ReactNode;
    isShareholderError: boolean;
    onStatusSelect: (status: string) => void;
};

const Person = (props: PersonProps) => {
    const {
        manualAddressesState,
        personIndex,
        toggleManualAddress,
        onAddressSelect,
        onAddressChange,
        disableBusinessIncome,
        disableMonthlyOtherHouseholdIncome,
        fetchedAddresses,
        onCountrySelect,
        formLayout
    } = props;

    const invalidClassName = ({ field }: { field: any }) => {
        if (_.isArray(field)) {
            return field.map((subfield) => {
                return classNames({
                    invalid:
                        subfield.touched &&
                        subfield.error &&
                        subfield.error.length
                });
            });
        }

        const fieldInvalid = field.touched && field.error ? true : false;
        return classNames({
            invalid: fieldInvalid
        });
    };

    const renderAddresses = (person: TPerson) => {
        const {
            uid: { value: personUID }
        } = person;

        const manualAddressState = manualAddressesState[personUID]
            ? manualAddressesState[personUID][0]
            : manualAddressesState[personIndex]
            ? manualAddressesState[personIndex][0]
            : false;

        return (
            <Address
                personIndex={personIndex}
                personUID={personUID}
                manualAddressState={manualAddressState}
                onManualAddress={toggleManualAddress}
                onChange={onAddressSelect}
                onAddressChange={onAddressChange}
                disableBusinessIncome={disableBusinessIncome}
                disableMonthlyOtherHouseholdIncome={
                    disableMonthlyOtherHouseholdIncome
                }
                addressIndex={0}
                fetchedAddresses={fetchedAddresses}
                field={person.addresses[0]}
                onCountrySelect={onCountrySelect}
            />
        );
    };

    const renderFormLayout = (formLayout: string, props: PersonProps) => {
        switch (formLayout) {
            case 'guarantor':
                return <GuarantorPerson {...props} />;
            default:
                return <LimitedCompanyPerson {...props} />;
        }
    };

    const newProps = _.merge({}, props, {
        renderAddresses: renderAddresses,
        renderPhones: renderPhones,
        invalidClassName: invalidClassName
    });

    return renderFormLayout(formLayout, newProps);
};

export default Person;
